import { BUSINESS_PLAN } from "@/config/site";
import { goToForm } from "@/lib/prefill";

export const BusinessPlan = () => (
  <section id="business-plan" className="bg-warm py-20 lg:py-28" data-testid="business-plan-section">
    <div className="container-ph grid gap-10 lg:grid-cols-12 lg:gap-16">
      <div className="reveal lg:col-span-5">
        <span className="gold-line mb-5" />
        <p className="eyebrow">Business Plan</p>
        <h2 className="h-section mt-3">{BUSINESS_PLAN.title}</h2>
        <p className="mt-5 text-base sm:text-lg text-ink/75 leading-relaxed">{BUSINESS_PLAN.intro}</p>
        <button className="btn-primary mt-9" onClick={() => goToForm(BUSINESS_PLAN.prefill)} data-testid="business-plan-button">{BUSINESS_PLAN.button}</button>
      </div>
      <ol className="reveal reveal-delay-1 lg:col-span-7 grid sm:grid-cols-2 gap-x-10">
        {BUSINESS_PLAN.items.map((it, i) => (
          <li key={it} className="flex items-baseline gap-4 border-b border-ivory-dark py-3.5">
            <span className="font-serif text-bronze text-lg w-7 shrink-0">{String(i + 1).padStart(2, "0")}</span>
            <span className="text-sm sm:text-base text-forest capitalize">{it}</span>
          </li>
        ))}
      </ol>
    </div>
  </section>
);
